import React, { useMemo } from 'react';
import { IMaterialCallout } from '../../../../entities-generated/common/material-callout';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { toSentence } from '../../../../framework/utils/string';
import { MaterialStatus } from '../../../../entities-generated/common/material-status';
import { toDateString } from '../../../../framework/utils/date-time';

interface IMaterialManagementListingProps {
  material: IMaterialCallout;
  onClick?: (material: IMaterialCallout) => void;
  onViewVendorSite: (material: IMaterialCallout) => void;
}

export const MaterialManagementListing: React.FunctionComponent<IMaterialManagementListingProps> = (props) => {
  const { material } = props;
  const subtitle = useMemo(() => {
    const total = (material.pricePerUnit * material.quantity) / 100;
    const ppu = material.pricePerUnit / 100;
    return `$${total.toFixed(2)} (${material.quantity} x $${ppu.toFixed(2)}/ea)`
  }, [material]);
  const status = useMemo(() => {
    const s = toSentence(MaterialStatus[material.procurementStatus]);
    const d = material.expectedDeliveryDate !== 0 ? toDateString(material.expectedDeliveryDate) : undefined;
    return !!d ? `${s}; arriving ${d}` : s;
  }, [material]);

  return (
    <BwjListing
      actions={[{
        icon: 'Globe',
        text: 'Go to vendor site',
        onClick: () => props.onViewVendorSite(material),
      }]}
      heading={material.description}
      secondaryLine={subtitle}
      teritaryLine={status}
      data={material}
      onClick={() => !!props.onClick && props.onClick(material)}
    />
  );
};
